export default __webpack_public_path__ + "static/media/page-bg.9e9f855d.webp";